export default (fileName: string): string | null => {
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex === -1) {
    return null;
  }

  return fileName.slice(dotIndex + 1).toUpperCase();
};
